// Helper: apply word filters on display (case-insensitive whole word replacement)
export const applyWordFilter = (text, filters) => {
  if (!text || !filters || filters.length === 0) return text;
  let result = text;
  filters.forEach(({ blocked, replacement }) => {
    if (blocked) {
      const regex = new RegExp(`\\b${blocked.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'gi');
      result = result.replace(regex, replacement || '***');
    }
  });
  return result;
};
